// src/lib/db.js
// ─────────────────────────────────────────────────────────
// All Firestore read/write operations live here.
// Components never call Firestore directly — they use these.
// ─────────────────────────────────────────────────────────

import {
  collection, doc, addDoc, getDoc, setDoc, updateDoc, deleteDoc,
  onSnapshot, serverTimestamp,
} from 'firebase/firestore';
import { db, APP_ID } from './firebase';

// ── Path helpers ──────────────────────────────────────────
const userRoot  = (uid)        => ['artifacts', APP_ID, 'users', uid];
const projCol   = (uid)        => collection(db, ...userRoot(uid), 'projects');
const projDoc   = (uid, id)    => doc(db,       ...userRoot(uid), 'projects',     id);
const txCol     = (uid)        => collection(db, ...userRoot(uid), 'transactions');
const txDoc     = (uid, id)    => doc(db,       ...userRoot(uid), 'transactions', id);

// ── Projects ──────────────────────────────────────────────
export const subscribeToProjects = (uid, callback) =>
  onSnapshot(projCol(uid), snap =>
    callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))), console.error);

export const createProject = async (uid, name) => {
  const ref = await addDoc(projCol(uid), {
    name: name.trim(),
    createdAt: serverTimestamp(),
  });
  return ref.id;
};

export const deleteProject = (uid, id) => deleteDoc(projDoc(uid, id));
export const getProjectById = async (uid, id) => {
  const snap = await getDoc(projDoc(uid, id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};
export const saveProjectTransactionSettings = async (uid, projectId, transactionSettings) =>
  setDoc(
    projDoc(uid, projectId),
    {
      transactionSettings,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );

// ── Transactions ──────────────────────────────────────────
export const subscribeToTransactions = (uid, callback) =>
  onSnapshot(txCol(uid), snap =>
    callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))), console.error);

export const addTransaction = async (uid, data) => {
  const ref = doc(txCol(uid));
  await setDoc(ref, { ...data, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
  return ref.id;
};

export const updateTransaction = async (uid, id, data) =>
  updateDoc(txDoc(uid, id), { ...data, updatedAt: serverTimestamp() });

export const deleteTransaction = (uid, id) => deleteDoc(txDoc(uid, id));
